$(function() {

	$( document ).ready(function() {

		var option = Math.floor(Math.random() * 4)+1;    
		$('#image-wrapper').prepend('<img src="images/captcha/'+option+'_securityimage.jpg" style="float: right;" />');

		$('#embed-form').on('submit', function(e){
			if ($(".loader").length > 0) {
				$(".loader").show();
			}
		    var radioButtons = $("#captcha-wrapper input:radio[name='image']");
		    var selectedIndex = radioButtons.index(radioButtons.filter(':checked'));
		    if(selectedIndex != option-1) {
		      e.preventDefault();
		      if ($('#embed-form .error-wrapper').length > 0) {
		      	$('#embed-form .error-wrapper').append( "<li>Please select correct description.</li>" );
		      }
		      else {
		      	$('#embed-form').append('<ul class="error-wrapper alert alert-danger"><li>Please select correct captcha image.</li></ul>');
		      	$(".loader").hide();
		      }
		    } 
		});
    });

});